import { motionValue as createMotionValue, isMotionValue, } from "motion-dom";
import { animateMotionValue } from "../interfaces/motion-value";
export function animateSingleValue(value, keyframes, options) {
    const motionValue = isMotionValue(value) ? value : createMotionValue(value);
    motionValue.start(animateMotionValue("", motionValue, keyframes, options));
    return motionValue.animation;
}
//# sourceMappingURL=single-value.js.map